import type { FieldErrors, SignupFields } from './use-form-state';
import { passwordRulesPass } from '@/utils/password-rules';
import { validatePhone } from '@/utils/phone-digits';

const MESSAGES: Record<string, string> = {
  required: 'Campo requerido',
  email_format: 'Email no válido',
  phone_format: 'Formato de teléfono no válido',
  phone_too_short: 'Número de teléfono incompleto',
  phone_too_long: 'Número de teléfono demasiado largo',
  password_invalid: 'La contraseña no cumple los requisitos',
  password_mismatch: 'Las contraseñas no coinciden',
  under_18: 'Debes ser mayor de 18 años',
  ig_taken: 'Este usuario de Instagram ya está registrado',
  email_taken: 'Este email ya está registrado',
  phone_taken: 'Este teléfono ya está registrado',
};

const BLOCK_REASONS: { prefix: string; msg: string }[] = [
  { prefix: 'banned_permanent', msg: 'No puedes registrarte con estos datos.' },
  {
    prefix: 'form failed',
    msg: 'No has pasado el filtro inicial. Inténtalo más tarde.',
  },
  {
    prefix: 'commitment failed',
    msg: 'Registro bloqueado temporalmente. Inténtalo más tarde.',
  },
];

const REQUIRED: (keyof SignupFields)[] = [
  'first_name',
  'last_name',
  'personal_ig_username',
  'email',
  'phone_prefix',
  'phone_number',
  'country',
  'city',
  'birthdate',
  'password',
];

export function translateFieldError(code: string): string {
  return MESSAGES[code] ?? code;
}

export function translateErrorMap(codes: FieldErrors): FieldErrors {
  const out: FieldErrors = {};
  (Object.keys(codes) as (keyof SignupFields)[]).forEach((k) => {
    const code = codes[k];
    if (code) out[k] = translateFieldError(code);
  });
  return out;
}

export function translateBlockReason(reason: string | undefined): string {
  if (!reason) return 'No puedes registrarte con estos datos.';
  const hit = BLOCK_REASONS.find((b) => reason.indexOf(b.prefix) === 0);
  return hit?.msg ?? 'No puedes registrarte con estos datos.';
}

export function validateClientSide(d: SignupFields): FieldErrors {
  const errs: FieldErrors = {};
  REQUIRED.forEach((k) => {
    if (!d[k]) errs[k] = 'required';
  });
  if (d.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email)) {
    errs.email = 'email_format';
  }
  if (d.phone_prefix && d.phone_number) {
    const res = validatePhone(
      d.phone_prefix + d.phone_number.replace(/\s/g, '')
    );
    if (!res.ok) errs.phone_number = res.code;
  }
  if (d.password && !passwordRulesPass(d.password, d.password_confirm)) {
    errs.password = 'password_invalid';
    if (d.password_confirm && d.password !== d.password_confirm) {
      errs.password_confirm = 'password_mismatch';
    }
  }
  return translateErrorMap(errs);
}
